/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contract_Service_FeeInputs */

const en_clients_field_contract_service_fee = /** @type {(inputs: Clients_Field_Contract_Service_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fee (%)`)
};

const pt_br2_clients_field_contract_service_fee = /** @type {(inputs: Clients_Field_Contract_Service_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa (%)`)
};

/**
* | output |
* | --- |
* | "Fee (%)" |
*
* @param {Clients_Field_Contract_Service_FeeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contract_service_fee = /** @type {((inputs?: Clients_Field_Contract_Service_FeeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contract_Service_FeeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contract_service_fee(inputs)
	return pt_br2_clients_field_contract_service_fee(inputs)
});